import React, { useState } from 'react';
import { ContactForm } from './ContactForm';
import blond from './assets/blond.jpg';
import Meta from './Meta';

export default function VirtualOfficePage() {
  const [isFormVisible, setFormVisible] = useState(false);

  const handleOpenForm = () => {
    setFormVisible(true);
  };

  const handleCloseForm = () => {
    setFormVisible(false);
  };

  const openButtonStyle = {
    backgroundColor: '#007bff',
    color: '#fff',
    padding: '12px 24px',
    border: 'none',
    borderRadius: '4px',
    fontSize: '1em',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
    marginTop: 30,
    display: 'block',
  };

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 999,
  };

  const modalStyle = {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    maxWidth: '600px',
    width: '90%',
    position: 'relative',
    boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
  };

  return (
      <React.Fragment>
      <Meta
         title="Виртуальный офис под ключ | DaaS для бизнеса | ИТ Особа"
         description="Внедряем виртуальные рабочие места за 1 день. Полный комплект: Windows, 1С, офисные программы, безопасность и резервное копирование. Снижаем IT-затраты на 40%!"
       />
    <div
      style={{
        fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
        maxWidth: '900px',
        margin: '0 auto',
        padding: '40px 20px',
        lineHeight: 1.6,
        backgroundColor: '#f9f9f9',
        color: '#333',
      }}
    >
      <h1
        style={{
          textAlign: 'center',
          marginBottom: '30px',
          color: '#2c3e50',
        }}
      >
        Виртуальный рабочий стол (DaaS) — ваш офис в облаке
      </h1>


      <p>
        Внедрите безопасный удалённый доступ для всей команды за 1 день. Работайте из любой точки мира на любом устройстве с полным набором корпоративных программ, включая 1С.
      </p>

      <h2 style={{ marginTop: '30px', color: '#34495e' }}>Проблемы, которые решает виртуальный офис от «ИТ Особа»:</h2>
      <p style={{ float: 'right', maxWidth: '40%', marginLeft: '20px', marginBottom: '10px' }}>
                 <img src={blond} alt="blond Illustration" style={{ width: '100%', height: 'auto' }} />
            </p>
      <ul>
        <li>
          <strong>У вас дорогое и сложное IT-оборудование?</strong> — Мы берем все затраты на инфраструктуру на себя. Вам нужен только интернет.
        </li>
        <li><strong>Сотрудники работают удалённо или в филиалах?</strong> — Даём одинаково защищённый доступ к рабочим программам всем, от бухгалтерии до отдела продаж.</li>
        <li><strong>Боитесь потери данных или кибератак?</strong> — Ваши данные хранятся в защищённых дата-центрах с ежедневным резервным копированием.</li>
        <li><strong>Тратите время и деньги на обновление ПО и настройку компьютеров?</strong> — Мы полностью администрируем все рабочие места: обновления, безопасность, техподдержка 24/7.</li>
      </ul>

      <h2 style={{ marginTop: '30px', color: '#34495e' }}>Что входит в решение «Виртуальный офис»?</h2>
      <p>Мы предоставляем полностью готовое к работе рабочее место для каждого сотрудника. Всё необходимое уже установлено и настроено:</p>
      <ul>
        <li>Операционная система Windows 10/11</li>
        <li>Офисный пакет Microsoft Office (Word, Excel, Outlook и др.)</li>
        <li>Бухгалтерские и учётные системы: 1С:Предприятие, Контур-Бухгалтерия и другие</li>
        <li>Корпоративный антивирус и система безопасности</li>
        <li>Любые специализированные программы по вашему запросу (САПР, графические редакторы, CRM)</li>
        <li>
          Ежедневное автоматическое резервное копирование всех данных
        </li>
        <li>Круглосуточная техническая поддержка и полное администрирование</li>
      </ul>
      <h2 style={{ marginTop: '30px', color: '#34495e' }}>Как это работает?</h2>
      <ul>
        <li>Вы оставляете заявку — мы подбираем оптимальный тариф и настраиваем тестовые места</li>
        <li>Мы разворачиваем виртуальную инфраструктуру — устанавливаем все необходимые программы, настраиваем доступы и безопасность</li>
        <li>Ваша команда начинает работу — сотрудники заходят в свой виртуальный кабинет с любого устройства и работают.</li>
        
      </ul>
      <h2 style={{ marginTop: '30px', color: '#34495e' }}>Кому особенно подходит эта услуга?</h2>
      <ul>
        <li>Среднему и малому бизнесу, который хочет снизить IT-бюджет</li>
        <li>Компаниям с удалёнными сотрудниками или филиалами</li>
        <li>Стартапам, которым нужна гибкая и масштабируемая IT-среда</li>
        <li>Организациям, работающим с конфиденциальными данными (финансы, юриспруденция, медицина)</li>
        <li>Проектным командам, собираемым на ограниченный срок</li>
        
      </ul>
      
      
      <p>Обратитесь к нам для консультации по подключению и настройке!</p>

      {/* <button style={openButtonStyle} onClick={handleOpenForm}>
        Заказать консультацию
      </button> */}

      {isFormVisible && (
        <div style={overlayStyle} onClick={handleCloseForm}>
          <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
            <div
              style={{
                position: 'absolute',
                top: 12,
                right: 12,
                width: 32,
                height: 32,
                cursor: 'pointer',
                borderRadius: '50%',
                backgroundColor: '#f0f0f0',
                color: '#333',
                fontSize: 24,
                fontWeight: 'bold',
                lineHeight: '32px',
                textAlign: 'center',
                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                transition: 'background-color 0.3s, color 0.3s, box-shadow 0.3s',
                userSelect: 'none',
              }}
              onClick={handleCloseForm}
              aria-label="Закрыть"
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#e0e0e0';
                e.currentTarget.style.color = '#000';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#f0f0f0';
                e.currentTarget.style.color = '#333';
                e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
              }}
              onMouseDown={(e) => {
                e.currentTarget.style.backgroundColor = '#d0d0d0';
                e.currentTarget.style.boxShadow = 'inset 0 2px 4px rgba(0,0,0,0.2)';
              }}
              onMouseUp={(e) => {
                e.currentTarget.style.backgroundColor = '#e0e0e0';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
              }}
            >
              ×
            </div>
            <ContactForm />
          </div>
        </div>
      )}
    </div>
    </React.Fragment>
  );
}